"use strict";

import jQuery from 'jquery';

/**
 * Control zum Zurücksetzen der Ansicht.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCZoomReset = function( options )
{
	gc.gis.control.GCAbstractMapControl.call( this, options );
};
gc.gis.control.GCZoomReset.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCZoomReset.prototype.init = function()
{
	this._render();
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCZoomReset.prototype._render = function()
{
	var self = this;

	if( !this._element )
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-zoom-reset'
		});

		this.__element_zoom_reset = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-zoom-world',
			title: 'Komplette Ansicht anzeigen',
			html: '<span>Komplette Karte anzeigen</span>',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
					// das setzend es Viewport würde auch die Projektion und die Rotation überschreiben, das ist hier nicht gewünscht
					// self._map.setViewport(gc.gis.iface.getLastView().viewport);

					var viewport = gc.gis.iface.getLastView().viewport;
					var format = gc.gis.iface.mapFactory.createFormat();
					var geom = format.readGeometry(viewport.geometry, gc.gis.format.WKT, viewport.projection);
					self._map.fitGeometry(geom);
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});
		this.__element_zoom_reset.prepend( jQuery('<span>', {
			'class': 'gc-icon ms ms-search-zoom'
		}) );

		this._element.append( this.__element_zoom_reset );
		gc.gis.iface.ui.tooltip(this.__element_zoom_reset, {
			placement: 'auto left'
		});
	}
	return this._element;
};

